import {LOCATION_CHANGE} from 'react-router-redux';

import {LINKS_LIST_ERROR, LINKS_LIST_REQUEST, LINKS_LIST_SUCCESS} from '../actions';

const initialState = {
        items: [],
        loading: false,
        endpoint: null,
        error: null
    },
    uniqueItems = (item, index, items) => items.findIndex(i => i.id === item.id) === index;

export default(state = initialState, action) => {
    switch (action.type) {
        case LOCATION_CHANGE:
            return initialState;
        case LINKS_LIST_ERROR:
            return {
                ...initialState,
                error: action.payload,
                loading: false
            };
        case LINKS_LIST_SUCCESS:
            const {
                    data: {
                        children,
                        ...data
                    }
                } = action.payload,
                items = children.map(child => child.data);
            console.log(action, {
                ...state,
                ...data,
                items: state
                    .items
                    .concat(items)
                    .filter(uniqueItems),
                loading: false
            });
            return {
                ...state,
                ...data,
                items: state
                    .items
                    .concat(items)
                    .filter(uniqueItems),
                loading: false
            };
        case LINKS_LIST_REQUEST:
            const {error, payload} = action;
            return {
                ...state,
                loading: true,
                endpoint: payload.endpoint,
                error: error
                    ? payload
                    : null
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/apps/client-reddit/reducers/links.js